<template>
    <div id="tableau">
    </div>
</template>

<script>
// import { filter } from 'vue/types/umd'
export default {
    name: 'Tableau',
    props: {
        url: String,
        options: {},
        width: Number,
        height: Number,
        filters: {},
        apiUrl: {
            default: 'https://public.tableau.com/javascripts/api/tableau-2.2.2.min.js'
        }
    },
    data () {
        return {
            viz: {},
            workBook: {}
        }
    },
    watch: {
        url () {
            if (this.viz) {
                this.viz.dispose()
            }
            this.initViz()
        },
        height (val) {
            this.viz.setFrameSize(parseInt(this.width), parseInt(val))
        },
        width (val) {
            this.viz.setFrameSize(parseInt(val), parseInt(this.height))
        },
        filters () {
            if (this.viz) {
                this.viz.dispose()
            }
            this.initViz()
        }
    },
    computed: {
        worksheet () {
            return this.workBook.getActiveSheet()
        }
    },
    methods: {
        initViz () {
            const containerDiv = document.getElementById("tableau")
            // Setting up constructor options
            let options = {}
            if (!this.options) {
                options = {
                    // height: this.height ? this.height : 1173,
                    width: this.width ? this.width : 1717,
                    hideTabs: true,
                    hideToolbar: true,
                    onFirstInteractive: () => { this.workBook = this.viz.getWorkbook() }
                }
                if (this.filters) {
                    Object.keys(this.filters).map((el) => {
                        options[el.toString()] = this.filters[el.toString()]
                    })
                }
            } else {
                options = this.options;
                // set default options
                // options.height = this.height ? this.height : 1200;
                options.width = this.width ? this.width : 1700;
                options.hideTabs = true;
                options.hideToolbar = true;
                options.optionsonFirstInteractive = () => { this.workBook = this.viz.getWorkbook() };
            }            
            this.viz = new window.tableau.Viz(containerDiv, this.url, options)
        },
        getFilters(callback) {
            const currentWorkbook = this.viz.getWorkbook();
            if (currentWorkbook) {
                let filterValues = {};
                currentWorkbook.getParametersAsync().then((p) => {
                    for(let i=0;i<p.length;i++){
                        let p_name = p[i].getName().slice(2);
                        let p_value = p[i].getCurrentValue();
                        filterValues[p_name] = p_value.value;
                    }
                    callback(filterValues);
                });
            }
        },
        showExportPDFDialog() {
            if (this.viz) {
                this.viz.showExportPDFDialog();
            }
        },
        undo() {
            if (this.viz) {
                this.viz.undoAsync();
            }
        },
        redo() {
            if (this.viz) {
                this.viz.redoAsync();
            }
        },
        revert() {
            if (this.viz) {
                this.viz.revertAllAsync();
            }
        }
    },
    beforeDestroy () {
        if (this.viz) {
            this.viz.dispose();
        }
    },
    mounted () {
        this.initViz()
    }
}
</script>